import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77103010"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M6.35355 5.64645C6.15829 5.45118 5.84171 5.45118 5.64645 5.64645C5.45118 5.84171 5.45118 6.15829 5.64645 6.35355L11.2929 12L5.64645 17.6464C5.45118 17.8417 5.45118 18.1583 5.64645 18.3536C5.84171 18.5488 6.15829 18.5488 6.35355 18.3536L12 12.7071L17.6464 18.3536C17.8417 18.5488 18.1583 18.5488 18.3536 18.3536C18.5488 18.1583 18.5488 17.8417 18.3536 17.6464L12.7071 12L18.3536 6.35355C18.5488 6.15829 18.5488 5.84171 18.3536 5.64645C18.1583 5.45118 17.8417 5.45118 17.6464 5.64645L12 11.2929L6.35355 5.64645Z",
    fill: "#858F9A"
  })
], -1))
const _hoisted_2 = [
  _hoisted_1
]

import { onBeforeUnmount, onMounted, ref } from "vue";
import { TSwipe } from "../../globals";


export default /*#__PURE__*/_defineComponent({
  __name: 'PopupContainer',
  emits: ["blur", "close", "swipe", "scroll"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

onMounted(() => {
  lockWindowScroll();
});

onBeforeUnmount(() => {
  unlockWindowScroll();
});

function onBlurHandler() {
  emit("blur");
}

function lockWindowScroll() {
  document.documentElement.style.overflow = "hidden";
}

function unlockWindowScroll() {
  document.documentElement.style.overflow = "";
}

function onSwipeHandler(direction: TSwipe) {
  emit("swipe", direction);
}

const contentWrapper = ref<HTMLElement | null>(null);
const contentWrapperSlot = {
  scrollToTop,
};
function scrollToTop() {
  contentWrapper.value?.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}

const isScrolled = ref(false);
const styles = {
  popupMarginTop: "60px",
};

function scrollHandler(e: Event) {
  const target = e.target as HTMLElement;
  const scrollTop = target.scrollTop;
  const topBarHeight = Number(styles.popupMarginTop.split(/[^0-9]/)[0]);

  isScrolled.value = scrollTop > topBarHeight;

  // Scroll position event
  const scrollBottom = target.scrollHeight - (target.offsetHeight + scrollTop);
  emit("scroll", {
    top: scrollTop,
    bottom: scrollBottom,
  });
}

return (_ctx: any,_cache: any) => {
  const _directive_touch = _resolveDirective("touch")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "frisbuy-popup-container",
    onClick: _cache[2] || (_cache[2] = _withModifiers(() => onBlurHandler(), ["self"]))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["frisbuy-popup-container__close-button-wrapper", {
        'frisbuy-popup-container__close-button-wrapper--colored': isScrolled.value,
      }]),
      style: _normalizeStyle({
        height: styles.popupMarginTop,
      })
    }, [
      _renderSlot(_ctx.$slots, "closeButton", {}, () => [
        _createElementVNode("button", {
          class: "frisbuy-close-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, _hoisted_2)
      ])
    ], 6),
    _createElementVNode("div", {
      class: "frisbuy-popup-container__content-wrapper",
      ref_key: "contentWrapper",
      ref: contentWrapper,
      style: _normalizeStyle({
        height: `calc(100dvh - ${styles.popupMarginTop})`,
      }),
      onScroll: _cache[1] || (_cache[1] = (e) => scrollHandler(e))
    }, [
      _renderSlot(_ctx.$slots, "content", _normalizeProps(_guardReactiveProps(contentWrapperSlot)))
    ], 36)
  ])), [
    [_directive_touch, (direction) => onSwipeHandler(direction), "swipe"]
  ])
}
}

})